<template>
<div class="unit-switch-wrapper">
    <div class="mobile-overlay" :class="{ show: shouldShowMobileSelector }" @click="hideMobileSelector"></div>
    <div class="d-none d-lg-flex d-xl-none unit-switch-mobile-toggle" @click="toggelMobileSelector">
        <img src="../creativate-icons/unit_prefs.svg"/>
    </div>
    <div class="unit-switch-desktop-toggles-wrapper" :class="{ show: shouldShowMobileSelector }">
        <input type="radio" id="unit-mm" value="millimeter" v-model="displayUnit" @change="setDisplayUnit">
        <label :class="{ active: mmIsActive() }" for="unit-mm">{{ t("display-unit.millimeter") }}</label>
        <input type="radio" id="unit-inch" value="inch" v-model="displayUnit" @change="setDisplayUnit">
        <label :class="{ active: !mmIsActive() }" for="unit-inch">{{ t("display-unit.inch") }}</label>
    </div>
</div>
</template>

<style lang="scss" scoped>
.unit-switch-wrapper {
    height: 100%;
    display: flex;
    align-items: center;
    position: relative;

    .mobile-overlay {
        background-color: none;
        width: 100vw;
        height: 100vh;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 10;
        display: none;

        &.show {
            display: block;
        }
    }

    .unit-switch-mobile-toggle {
        z-index: 20;
        height: 100%;
        display: flex;
        align-items: center;

        img {
            min-width: 22px;
        }
    }

    .unit-switch-desktop-toggles-wrapper {
        height: 100%;
        display: flex;
        align-items: center;
        z-index: 20;
        transition: visibility 0s, opacity 0.1s;

        @media screen and (min-width: 992px) and (max-width: 1199px) {
            display: flex;
            visibility: hidden;
            position: absolute;
            top: 50px;
            background-color: #ffffff;
            box-shadow: 0px 0px 15px 0px #0000001F;
            padding: 10px 20px;
            border-radius: 4px;
            left: -100px;
            flex-wrap: nowrap;
            opacity: 0;

            &.show {
                display: flex;
                visibility: visible;
                opacity: 1;
            }
        }

        input {
            cursor: pointer;
        }

        label {
            cursor: pointer;
            color: #000000;
            font-size: 16px;
            font-weight: 400;
            margin-top: 3px;
            border-bottom: 3px solid rgba(0, 0, 0, 0);
            margin-right: 19px;

            &:last-child {
                margin-right: 0;
            }

            &:hover {
                border-bottom: 3px solid #753E7C;
            }

            &.active {
                border-bottom: 3px solid #753E7C;
            }
        }
    }
}
</style>

<script>

import $ from "jquery";
import {
    translate,
    isLoggedIn
} from "../utils/utils";

export default {
    name: "UnitSwitch",
    computed: {
        displayUnit: {
            get() {
                return this.$store.state.displayUnit;
            },
            set(value) {
                this.$store.commit("updateDisplayUnit", value);
            }
        },
    },
    data: () => ({
        shouldShowMobileSelector: false,
    }),
    created: function () {
        this.getDisplayUnit();
    },
    methods: {
        getDisplayUnit: function () {
            const url = window.location.origin + "/api/user/unit";

            // Get value from user if it's not in local storage
            if (!this.displayUnit) {
                if (isLoggedIn()) {
                    $.getJSON(
                        url,
                        (data) => {
                            if (data.unit) {
                                this.$store.commit("updateDisplayUnit", data.unit);
                            } else {
                                this.$store.commit("updateDisplayUnit", "millimeter");
                                this.setDisplayUnit();
                            }
                        },
                    ).fail(() => {
                        this.$store.commit("updateDisplayUnit", "millimeter");
                        this.setDisplayUnit();
                    });
                } else {
                    this.$store.commit("updateDisplayUnit", "millimeter");
                }
            }
        },
        mmIsActive: function() {
            return this.displayUnit === "millimeter";
        },
        setDisplayUnit: function() {
            const url = window.location.origin + "/api/user/unit";
            const displayUnit = this.displayUnit;
            if (isLoggedIn()) {
                $.post(
                    url, {
                        unit: this.displayUnit
                    }
                ).always(event => {
                    // Send analytics event.
                    var parameters = {
                        unit: displayUnit,
                    };
                    const url = window.location.origin + "/api/mysewnet/event/library-set-unit";
                    $.post(url, parameters);
                });

                // Send analytics event.

                $.post()
            }
            
        },
        showMobileSelector: function() {
            this.shouldShowMobileSelector = true;
        },
        toggelMobileSelector: function() {
            this.shouldShowMobileSelector = !this.shouldShowMobileSelector;
        },
        hideMobileSelector: function() {
            this.shouldShowMobileSelector = false;
        },
        mobileMouseLeave: function() {
            this.shouldShowMobileSelector = false;
        },
        t(key, variables) {
            return translate(key, variables);
        }
    },
}
</script>
